// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federbelastungsgrenze/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federbelastungsgrenzeDE: PageEntry = {
  id: "post.federbelastungsgrenze",
  locale: "de",
  slug: "federbelastungsgrenze",
  seo: {
    title: "Glossar: Federbelastungsgrenze einfach erklärt | Dietz GmbH",
    description: "Die Federbelastungsgrenze ist der Punkt, an dem eine Feder ihre maximale Belastung erreicht, ohne dauerhafte Verformung oder Schädigung zu erfahren. Dieser Wert ist entscheidend fü",
  },
  type: "post",
  h1: "Glossar: Federbelastungsgrenze einfach erklärt",
  intro: "Die Federbelastungsgrenze ist der Punkt, an dem eine Feder ihre maximale Belastung erreicht, ohne dauerhafte Verformung oder Schädigung zu erfahren. Dieser Wert ist entscheidend für die Festlegung der Einsatzgrenzen einer Feder in einem bestimmten System. Die Belastungsgrenze hängt von verschiedenen Faktoren ab, darunter das verwendete Federmaterial, die Konstruktion und die Umgebungsbedingungen. Eine genaue Kenntnis der Federbelastungsgrenze ist entscheidend, um eine sichere und zuverlässige Leistung der Feder über ihre Lebensdauer zu gewährleisten.",
  blocks: [

  ],
};
